<template>
    <sa-page-layout titolo="AnDIamo - PAI" class="sa-no-space" btnRouterBackVisible btnRefreshVisible @refresh="onRefresh">
        <template slot="toolbar">
            <b-button variant="outline-info btn-toolbar sa-margin-right float-sm-right" @click="onClickAggiornaDaAndiamo">
                <i class="fas fa-cloud-download-alt"></i>
                Aggiorna da AnDIamo
            </b-button>
        </template>
        <template slot="table-body">
            <AndiamoPaiViewComponent ref="cmpAndiamoPaiViewComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AndiamoPaiViewComponent from "../components/AndiamoPaiViewComponent.vue";

export default {
    components: { SaPageLayout, AndiamoPaiViewComponent },
    methods: {
        onRefresh() {
            this.$refs.cmpAndiamoPaiViewComponent.loadData();
        },
        onClickAggiornaDaAndiamo() {
            this.$refs.cmpAndiamoPaiViewComponent.onClickAggiornaDaAndiamo();
        },
    },
};
</script>

<style lang="scss" scoped></style>
